import { render, staticRenderFns } from "./ManagementProfileRootView.vue?vue&type=template&id=4face809"
import script from "./ManagementProfileRootView.vue?vue&type=script&lang=js"
export * from "./ManagementProfileRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports